// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function UserActionsFromJSON(json) {
    return {
        'createPortfolio': !exists(json, 'createPortfolio') ? undefined : json['createPortfolio'],
        'updatePortfolio': !exists(json, 'updatePortfolio') ? undefined : json['updatePortfolio'],
        'importData': !exists(json, 'importData') ? undefined : json['importData'],
        'exportData': !exists(json, 'exportData') ? undefined : json['exportData'],
        'uploadBenchmarks': !exists(json, 'uploadBenchmarks') ? undefined : json['uploadBenchmarks'],
        'accessSharedFolder': !exists(json, 'accessSharedFolder') ? undefined : json['accessSharedFolder'],
        'importExportHistory': !exists(json, 'importExportHistory') ? undefined : json['importExportHistory'],
        'configurePermissions': !exists(json, 'configurePermissions') ? undefined : json['configurePermissions'],
        'accessPreqinPro': !exists(json, 'accessPreqinPro') ? undefined : json['accessPreqinPro'],
        'accessDatapoints': !exists(json, 'accessDatapoints') ? undefined : json['accessDatapoints'],
        'accessEntities': !exists(json, 'accessEntities') ? undefined : json['accessEntities'],
        'accessUserSettings': !exists(json, 'accessUserSettings') ? undefined : json['accessUserSettings'],
        'accessPortfolioGraph': !exists(json, 'accessPortfolioGraph') ? undefined : json['accessPortfolioGraph'],
        'accessDocumentLibrary': !exists(json, 'accessDocumentLibrary') ? undefined : json['accessDocumentLibrary'],
        'accessTags': !exists(json, 'accessTags') ? undefined : json['accessTags'],
        'accessDashboards': !exists(json, 'accessDashboards') ? undefined : json['accessDashboards'],
        'accessCommitmentPacing': !exists(json, 'accessCommitmentPacing') ? undefined : json['accessCommitmentPacing'],
        'accessCampaign': !exists(json, 'accessCampaign') ? undefined : json['accessCampaign'],
        'accessMarkets': !exists(json, 'accessMarkets') ? undefined : json['accessMarkets'],
        'accessStandardActions': !exists(json, 'accessStandardActions') ? undefined : json['accessStandardActions'],
    };
}
export function UserActionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'createPortfolio': value.createPortfolio,
        'updatePortfolio': value.updatePortfolio,
        'importData': value.importData,
        'exportData': value.exportData,
        'uploadBenchmarks': value.uploadBenchmarks,
        'accessSharedFolder': value.accessSharedFolder,
        'importExportHistory': value.importExportHistory,
        'configurePermissions': value.configurePermissions,
        'accessPreqinPro': value.accessPreqinPro,
        'accessDatapoints': value.accessDatapoints,
        'accessEntities': value.accessEntities,
        'accessUserSettings': value.accessUserSettings,
        'accessPortfolioGraph': value.accessPortfolioGraph,
        'accessDocumentLibrary': value.accessDocumentLibrary,
        'accessTags': value.accessTags,
        'accessDashboards': value.accessDashboards,
        'accessCommitmentPacing': value.accessCommitmentPacing,
        'accessCampaign': value.accessCampaign,
        'accessMarkets': value.accessMarkets,
        'accessStandardActions': value.accessStandardActions,
    };
}
